import { graphql, useStaticQuery } from "gatsby"
import React, { useState, useEffect } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import { siteUrl } from "../../../utils/siteUrl"
import Button from "../../atoms/button/button"
import ConsultingItem from "../../atoms/consulting-item/consulting-item"
import TitleTab from "../../atoms/title-tab/title-tab"
import "./section-consulting.scss"
import { pushDataLayerEvent } from "../../../utils/metricManagementUtil"

const SectionConsulting = ({ mobile, home }) => {
  const resultQuery = useStaticQuery(
    graphql`
      query PATERN_INFO_CONSULTING {
        allContentfulNolConsultorios {
          nodes {
            node_locale
            descripcionDelConsultorio {
              descripcionDelConsultorio
            }
            titulo
            imagenMedica {
              file {
                url
              }
              description
            }
          }
        }
        allContentfulNolHome {
          nodes {
            node_locale
            consultorios {
              descripcionHome {
                json
              }
            }
          }
        }
      }
    `
  )
  const contentInfo = resultQuery.allContentfulNolConsultorios.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const infoConsultorio = resultQuery.allContentfulNolHome.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const [contentInfoList, setContentInfoList] = useState([])
  const [isShowSexologist, setIsShowSexologist] = useState(false)
  const [slidesToShow, setSlidesToShow] = useState(2)

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g, "T")
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  const consultingRediret = () => {
    window.location.href = siteUrl + "/entre-nosotras/consultorios"
  }

  const dataLayerConsulting = (url) => {
    pushDataLayerEvent({
      event: "cta_click",
      link_text: "Consultar ahora" ,
      link_url: url,
      link_domain: window.location.hostname.split('www.')[0],
      link_id: "",
      link_classes: ""
    })
  }
  var settings = {
    slidesToShow: mobile ? 1 : slidesToShow,
    dots: !!mobile,
    slidesToScroll: 1,
    infinite: true,
  }

  useEffect(() => {
    if (
      process.env.LOCALE === "es-CO" &&
      localStorage.getItem("TOKEN_INFO") &&
      localStorage.getItem("USER_INFO") &&
      calculateAge() >= 18
    ) {
      setIsShowSexologist(true)
    }
  }, [])

  useEffect(() => {
    let newContenInfoList
    if (isShowSexologist) {
      newContenInfoList = [...contentInfo]
    } else {
      newContenInfoList = contentInfo.filter(item => {
        return item.titulo !== "Sexóloga"
      })
    }
    newContenInfoList = contentInfo.filter(item => {
      return item.titulo !== "contenido-oculto"
    })
    setSlidesToShow(newContenInfoList.length > 2 ? 3 : 2)
    setContentInfoList([...newContenInfoList])
  }, [isShowSexologist])

  var consultingLink = siteUrl + "/entre-nosotras/consultorios"
  return (
    <section className="f-section-consulting-container">
      <div className="f-section-consulting-container-wrap">
        <TitleTab className="f-TitleTab f-TitleTab-pink" title="Consultorios" />

        <Slider {...settings} className="f-carousel-consulting">
          {contentInfoList.map(info => {
            return (
              <ConsultingItem
                title={info.titulo}
                alt={info.imagenMedica.description}
                imgUrl={info.imagenMedica.file.url}
                description={
                  info.titulo === "Bullying"
                    ? infoConsultorio[0].consultorios[1].descripcionHome.json
                    : info.descripcionDelConsultorio.descripcionDelConsultorio
                }
                key={JSON.stringify(info)}
              />
            )
          })}
        </Slider>
        <div
          className="f-consulting-btn-container"
          onClick={e => {
            e.preventDefault()
            consultingRediret()
          }}
        >
          <a href={consultingLink} onClick={()=>dataLayerConsulting(consultingLink)}>
            <Button
              className="new-dark-blue short f-consulting-button"
              title="Consultar ahora"
            />
          </a>
        </div>
      </div>
    </section>
  )
}

export default SectionConsulting
